import { createFileRoute, Outlet } from '@tanstack/react-router';

import { requireAuthenticatedRoute } from '@/lib/router-guards';

export const Route = createFileRoute('/onboarding')({
    beforeLoad: requireAuthenticatedRoute,
    component: OnboardingLayoutRoute
});

function OnboardingLayoutRoute() {
    return <Outlet />;
}
